export default __webpack_public_path__ + "static/media/graignes13.ea2707ad.jpg";